'use es6';

import configureFn from '../ConfigureDecorator/configure';
export const configure = configureFn;